<template>
    <CommonComponentsSolutionsVideoGroup :arrows-list="ArrowsList" />
</template>

<script setup lang="ts">
    import { reactive, onMounted } from 'vue';
    import path1 from '@assets/Video/home/procedure_planing.mp4';
    import videoPosterPath1 from '@assets/Video/home/procedure_planing.jpg';
    import pathCN1 from '@assets/Video/solutions/brand/CN/1.mp4';
    import videoPosterPathCN1 from '@assets/Video/solutions/brand/CN/1.jpg';

    import path2 from '@assets/Video/solutions/brand/brandVideo2.mp4';
    import videoPosterPath2 from '@assets/Video/solutions/brand/brandVideo2.jpg';
    import pathCN2 from '@assets/Video/solutions/brand/CN/2.mp4';
    import videoPosterPathCN2 from '@assets/Video/solutions/brand/CN/2.jpg';

    import path3 from '@assets/Video/solutions/brand/brandVideo3.mp4';
    import videoPosterPath3 from '@assets/Video/solutions/brand/brandVideo3.jpg';
    import pathCN3 from '@assets/Video/solutions/brand/CN/3.mp4';
    import videoPosterPathCN3 from '@assets/Video/solutions/brand/CN/3.jpg';

    import path4 from '@assets/Video/home/procedure_marketing.mp4';
    import videoPosterPath4 from '@assets/Video/home/procedure_marketing.jpg';
    import pathCN4 from '@assets/Video/solutions/brand/CN/4.mp4';
    import videoPosterPathCN4 from '@assets/Video/solutions/brand/CN/4.jpg';
    // path1实际上是首页的流程图的第一个：产品企划 Planning 视频
    // path4实际上是首页的流程图的最后一个：数字营销 Digital Marketing 视频
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();

    const ArrowsList = reactive<Array<ArrowsListItem>>([
        {
            key: '01',
            title: 'global_solutions_brand_Arrows_titleCN_1',
            rightText: [
                'global_solutions_brand_Arrows_rightText_1_1',
                'global_solutions_brand_Arrows_rightText_1_2',
                'global_solutions_brand_Arrows_rightText_1_3',
            ],

            videos: [
                {
                    path: pathCN1,
                    poster: videoPosterPathCN1,
                },
            ],
        },
        {
            key: '02',
            title: 'global_solutions_brand_Arrows_titleCN_2',
            rightText: [
                'global_solutions_brand_Arrows_rightText_2_1',
                'global_solutions_brand_Arrows_rightText_2_2',
                'global_solutions_brand_Arrows_rightText_2_3',
            ],

            videos: [
                {
                    path: pathCN2,
                    poster: videoPosterPathCN2,
                },
            ],
        },
        {
            key: '03',
            title: 'global_solutions_brand_Arrows_titleCN_3',
            rightText: [
                'global_solutions_brand_Arrows_rightText_3_1',
                'global_solutions_brand_Arrows_rightText_3_2',
                'global_solutions_brand_Arrows_rightText_3_3',
            ],
            videos: [
                {
                    path: pathCN3,
                    poster: videoPosterPathCN3,
                },
            ],
        },
        {
            key: '04',
            title: 'global_solutions_brand_Arrows_titleCN_4',
            rightText: [
                'global_solutions_brand_Arrows_rightText_4_1',
                'global_solutions_brand_Arrows_rightText_4_2',
                'global_solutions_brand_Arrows_rightText_4_3',
            ],
            videos: [
                {
                    path: pathCN4,
                    poster: videoPosterPathCN4,
                },
            ],
        },
    ]);
    onMounted(() => {
        addSlideInUp('.one');
        addSlideInDown('.two');
    });
</script>
